import { render, staticRenderFns } from "./Postulaciones.vue?vue&type=template&id=4f92eec2"
import script from "./Postulaciones.vue?vue&type=script&lang=js"
export * from "./Postulaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports